module.exports = __webpack_public_path__ + "static/img/6.84220710.png";